"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
var Manager_1 = __importDefault(require("./Manager"));
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var Provider_default_json_1 = __importDefault(require("../configs/Provider.default.json"));
var DeploymentContext_default_json_1 = __importDefault(require("../configs/DeploymentContext.default.json"));
var Web3Loader = (function () {
    function Web3Loader() {
        this._defaultProviderConfig = Provider_default_json_1.default;
        this._defaultProvidersConfig = {
            defaultProvider: '1337.localhost',
            providers: {
                '1337': {
                    localhost: this._defaultProviderConfig,
                },
            },
        };
        this._defaultDeploymentContextConfig = DeploymentContext_default_json_1.default;
        this._defaultDeploymentContextsConfig = {
            '1337': {
                localhost: this._defaultDeploymentContextConfig,
            },
        };
    }
    Web3Loader.prototype.loadEnvironment = function (providerConfig, deploymentContextConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var providerToLoad, deploymentContextToLoad, _a, providersConfig, deploymentContextsConfig, manager;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        providerToLoad = [this._defaultProviderConfig];
                        if (process.env.PROVIDER_URL || process.env.REACT_APP_PROVIDER_URL) {
                            providerToLoad.push(process.env.PROVIDER_URL || process.env.REACT_APP_PROVIDER_URL);
                        }
                        if (providerConfig) {
                            providerToLoad.push(providerConfig);
                        }
                        deploymentContextToLoad = [this._defaultDeploymentContextConfig];
                        if (process.env.DEPLOYMENT_CONTEXT_URL || process.env.REACT_APP_DEPLOYMENT_CONTEXT_URL) {
                            deploymentContextToLoad.push(process.env.DEPLOYMENT_CONTEXT_URL || process.env.REACT_APP_DEPLOYMENT_CONTEXT_URL);
                        }
                        if (deploymentContextConfig) {
                            deploymentContextToLoad.push(deploymentContextConfig);
                        }
                        console.debug('Loading environment configurations...');
                        return [4, Promise.all([
                                this._buildProvidersConfig(providerToLoad, true),
                                this._buildNetworkDeploymentsConfig(deploymentContextToLoad),
                            ])];
                    case 1:
                        _a = _b.sent(), providersConfig = _a[0], deploymentContextsConfig = _a[1];
                        console.debug('Environment configurations loaded');
                        console.debug('Provider configuration:', JSON.stringify(providersConfig));
                        console.debug('Deployment context configuration:', JSON.stringify(deploymentContextsConfig));
                        manager = new Manager_1.default(providersConfig, deploymentContextsConfig);
                        return [2, manager.getEnvironment()];
                }
            });
        });
    };
    Web3Loader.prototype.loadManager = function (providersConfigs, deploymentContextsConfigs) {
        return __awaiter(this, void 0, void 0, function () {
            var providersToLoad, deploymentContextsToLoad, _a, providersConfig, deploymentContextsConfig, manager;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        providersToLoad = [this._defaultProvidersConfig];
                        if (process.env.PROVIDERS_URLS || process.env.REACT_APP_PROVIDERS_URLS) {
                            providersToLoad.push.apply(providersToLoad, (process.env.PROVIDERS_URLS || process.env.REACT_APP_PROVIDERS_URLS).split(' '));
                        }
                        if (Array.isArray(providersConfigs)) {
                            providersToLoad.push.apply(providersToLoad, providersConfigs);
                        }
                        else {
                            providersToLoad.push(providersConfigs);
                        }
                        deploymentContextsToLoad = [this._defaultDeploymentContextsConfig];
                        if (process.env.DEPLOYMENT_CONTEXTS_URLS || process.env.REACT_APP_DEPLOYMENT_CONTEXTS_URLS) {
                            deploymentContextsToLoad.push.apply(deploymentContextsToLoad, (process.env.DEPLOYMENT_CONTEXTS_URLS || process.env.REACT_APP_DEPLOYMENT_CONTEXTS_URLS).split(' '));
                        }
                        if (Array.isArray(deploymentContextsConfigs)) {
                            deploymentContextsToLoad.push.apply(deploymentContextsToLoad, deploymentContextsConfigs);
                        }
                        else {
                            deploymentContextsToLoad.push(deploymentContextsConfigs);
                        }
                        console.debug('Loading environments configurations...');
                        return [4, Promise.all([
                                this._buildProvidersConfig(providersToLoad, false),
                                this._buildNetworkDeploymentsConfig(deploymentContextsToLoad),
                            ])];
                    case 1:
                        _a = _b.sent(), providersConfig = _a[0], deploymentContextsConfig = _a[1];
                        console.debug('Environments configurations loaded');
                        console.debug('Providers configuration:', JSON.stringify(providersConfig));
                        console.debug('Deployment contexts configuration:', JSON.stringify(deploymentContextsConfig));
                        manager = new Manager_1.default(providersConfig, deploymentContextsConfig);
                        return [2, manager];
                }
            });
        });
    };
    Web3Loader.prototype._convertToMultiProviders = function (providerConfig, makeDefault) {
        var providers = {};
        providers[providerConfig.chainId] = {};
        providers[providerConfig.chainId][providerConfig.name] = providerConfig;
        var converted = { providers: providers };
        if (makeDefault) {
            converted.defaultProvider = providerConfig.chainId + "." + providerConfig.name;
        }
        return converted;
    };
    Web3Loader.prototype._buildProvidersConfig = function (configs, updateDefault) {
        return __awaiter(this, void 0, void 0, function () {
            var configurations, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(configs.map(function (configItem) {
                            if (typeof configItem === 'string') {
                                console.log("fetching " + configItem);
                                return fetch(configItem)
                                    .then(function (response) { return response.json(); })
                                    .then(function (json) {
                                    var asSingle = json;
                                    if (asSingle.name === undefined) {
                                        return json;
                                    }
                                    var converted = _this._convertToMultiProviders(asSingle, updateDefault);
                                    return converted;
                                })
                                    .catch(function (e) {
                                    console.error("error loading " + typeof configItem + " config from " + configItem, e);
                                    var emptyConfig = { providers: {} };
                                    return emptyConfig;
                                });
                            }
                            else {
                                var asSingle = configItem;
                                if (asSingle.name === undefined) {
                                    return Promise.resolve(configItem);
                                }
                                var converted = _this._convertToMultiProviders(asSingle, updateDefault);
                                return Promise.resolve(converted);
                            }
                        }))];
                    case 1:
                        configurations = _a.sent();
                        result = configurations.reduce(function (prev, curr) { return lodash_merge_1.default(prev, curr); });
                        return [2, result];
                }
            });
        });
    };
    Web3Loader.prototype._convertToMultiNetworksDeployments = function (deploymentContextConfig) {
        var converted = {};
        converted[deploymentContextConfig.chainId] = {};
        converted[deploymentContextConfig.chainId][deploymentContextConfig.name] = deploymentContextConfig;
        return converted;
    };
    Web3Loader.prototype._buildNetworkDeploymentsConfig = function (configs) {
        return __awaiter(this, void 0, void 0, function () {
            var configurations, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(configs.map(function (configItem) {
                            if (typeof configItem === 'string') {
                                console.log("fetching " + typeof configItem + " config from " + configItem);
                                return fetch(configItem)
                                    .then(function (response) { return response.json(); })
                                    .then(function (json) {
                                    var asSingle = json;
                                    if (asSingle.name === undefined) {
                                        return json;
                                    }
                                    var converted = _this._convertToMultiNetworksDeployments(asSingle);
                                    return converted;
                                })
                                    .catch(function (e) {
                                    console.error("error loading " + typeof configItem + " config from " + configItem, e);
                                    var emptyConfig = {};
                                    return emptyConfig;
                                });
                            }
                            else {
                                var asSingle = configItem;
                                if (asSingle.name === undefined) {
                                    return Promise.resolve(configItem);
                                }
                                var converted = _this._convertToMultiNetworksDeployments(asSingle);
                                return Promise.resolve(converted);
                            }
                        }))];
                    case 1:
                        configurations = _a.sent();
                        result = configurations.reduce(function (prev, curr) { return lodash_merge_1.default(prev, curr); });
                        return [2, result];
                }
            });
        });
    };
    return Web3Loader;
}());
exports.default = Web3Loader;
//# sourceMappingURL=Loader.js.map